export default __webpack_public_path__ + "static/media/Mismatch_icon.d2fccffb.svg";